import { render, staticRenderFns } from "./salles.vue?vue&type=template&id=c3c717d8&scoped=true&"
import script from "./salles.vue?vue&type=script&lang=js&"
export * from "./salles.vue?vue&type=script&lang=js&"
import style0 from "./salles.vue?vue&type=style&index=0&id=c3c717d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c717d8",
  null
  
)

export default component.exports